import { Grid, Paper, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { getIconSize, getScreenSize } from "./getScreenSize";
import theme from "../theme";


interface FeatureIconProps {
  src: string;
  path: string;
  title: string;
  download?(): void;
}

export function FeatureIcon(props: FeatureIconProps) {
  const { title, download, src, path } = props;
  const width = window.screen.width;
  const screenSize = getScreenSize(width);
  const icon_size = getIconSize(screenSize);

  return (
    <Paper sx={{[theme.breakpoints.up("xs")]: {
      height: '11em'
          }, [theme.breakpoints.up("md")]: {
            height: '9em'
                }, [theme.breakpoints.up("lg")]: {
            height: '13em'}}}>
      <Link style={{ textDecoration: "none", [theme.breakpoints.up("xs")]: {
      height: '11em'
          },  [theme.breakpoints.up("lg")]: {
            height: '13em'} }} to={path}>
        <Grid container sx={{ padding: '1em'}} >
  
  
        
              <Grid item xs={12} display={'flex'} justifyContent={'center'}   >
                <img
                  src={src}
                  alt="//"
                  style={{  objectFit: "contain", alignSelf:'center',color: "primary", width: '50%'
                       }}
                />
              </Grid>
        
   
          <Grid item xs={12} >
            <Typography sx={{[theme.breakpoints.up("xs")]: {
      fontSize: 16
          },  [theme.breakpoints.up("lg")]: {
           fontSize: 24},  color: 'primary'}} onClick={download ? () => download() : () => {}} align="center">
              {title}
            </Typography>
          </Grid>
        </Grid>
      </Link>
    </Paper>
  );
}
